<template>
    <div v-if="shouldShowCart" class="candidate-cart" style="display: flex; align-items: center;">
        <div class="avatar-section">
            <div v-for="(profile, index) in firstThreeProfiles" :key="index" style="width: 46px;">
                <img :src="profile.avatar_url">
            </div>
        </div>
        <div class="counter-section" style="font-size: 24px; color: #3C3C3C; margin-right: 10px;"
            v-if="CandidateBoardStore.getProfileCount() - 3 > 0">
            +{{ CandidateBoardStore.getProfileCount() - 3 }}
        </div>
        <div class="open-candidate-board-btn" :class="{ disabled: CandidateBoardStore.getProfileCount() == 0 }"
            @click="openStartModal()" :id="searchButtonId">
            <img src="/media/images/web_search/vacancies_board.svg">
            <div>{{ CandidateBoardStore.getProfileCount() }}</div>
            <span class="active">{{ $trans('web_search.open_candidate_board_here') }}</span>
            <span class="disabled">{{ $trans('web_search.no_candidate_selected') }}</span>
        </div>
    </div>
</template>

<script>
import { mapStores } from 'pinia'
import { useCandidateBoardStore } from '@/stores/CandidateBoardStore'

export default {
    props: {
        profiles: {
            type: Array,
            required: false,
        },
        isMobile: {
            type: Boolean,
            required: true,
        },
        groupName: String,
    },
    computed: {
        ...mapStores(useCandidateBoardStore), // useCandidateBoardStore => this.CandidateBoardStore
        firstThreeProfiles() {
            return this.CandidateBoardStore.getProfiles().slice(0, 3);
        },

        shouldShowCart() {
            return !this.isMobile || this.CandidateBoardStore.getProfileCount() > 0;
        },
        searchButtonId() {
            switch (this.groupName) {
                case 'Deutsche Interim AG':
                    return 'di_request_candidateboard';
                case 'Swiss Interim GmbH':
                    return 'si_request_candidateboard';
                case 'Matchmaker':
                    return 'mm_request_candidateboard';
                default:
                    return 'di_request_candidateboard';
            }
        },
    },
    methods: {
        openStartModal() {
            if (this.CandidateBoardStore.getProfileCount()) {
                this.$emit('show');
            }
        }
    },
}
</script>

<style scoped>
.candidate-cart {
    position: absolute;
    right: 0;
    top: 41px;
}

.avatar-section {
    display: flex;
    margin-right: 40px;
}

.avatar-section img {
    width: 66px;
    height: 66px;
    border-radius: 50%;
    border: 4px solid white;
}

.open-candidate-board-btn {
    background-color: #41abc4;
    width: 250px;
    height: 65px;
    display: flex;
    color: #fff;
    padding: 5px;
    border-radius: 4px;
    border: 1px solid #BCBAB6;
    margin-top: 16px;
}

.open-candidate-board-btn>span.active {
    display: block;
}

.open-candidate-board-btn>span.disabled {
    display: none;
}

.open-candidate-board-btn.disabled>span.active {
    display: none;
}

.open-candidate-board-btn.disabled>span.disabled {
    display: block;
}

.open-candidate-board-btn>span {
    margin-left: 15px;
    align-self: center;
}

.open-candidate-board-btn div {
    border: 2px solid #fff;
    border-radius: 50%;
    height: 23px;
    width: 23px;
    position: absolute;
    margin-left: 35px;
    margin-top: -2px;
    background-color: #ea975a;
    text-align: center;
    color: #fff;
    display: flex;
    justify-content: center;
    align-items: center;
}

.open-candidate-board-btn.disabled div {
    background-color: #747474;
}

.open-candidate-board-btn:not(.disabled):hover {
    background-color: #2699b2;
    cursor: pointer;
}

.open-candidate-board-btn.disabled {
    background-color: #fff;
    color: #000000;
}

.open-candidate-board-btn:not(.disabled) img {
    filter: brightness(0%) hue-rotate(360deg) saturate(1000%) contrast(1000%) invert(100%);
}

@media only screen and (max-width: 790px) {
    
    .avatar-section {
        display: none;
    }

    .candidate-cart {
        position: absolute !important;
        right: unset !important;
        top: -1px !important;
        scale: 0.8 !important;
        margin-left: 240px !important;
    }

    .counter-section {
        display: none;
    }

    .open-candidate-board-btn {
        width: 50px;
        background-color: transparent;
        border-color: transparent;
    }

    .open-candidate-board-btn:hover {
        background-color: transparent !important;
    }

    .open-candidate-board-btn.disabled {
        background-color: transparent;
    }

    .open-candidate-board-btn div {
        background-color: #ea975a;
    }

    .open-candidate-board-btn span {
        display: none !important;
    }

    .open-candidate-board-btn .arrow-in-circle {
        display: none;
    }

    .open-candidate-board-btn:not(.disabled) img {
        filter: brightness(0) saturate(100%) invert(62%) sepia(46%) saturate(584%) hue-rotate(144deg) brightness(90%) contrast(82%);
    }
}
</style>